let galleryLoader;
const gallerySelector = 'gallery-section, .photoswipe';
const loadGallery = () => {
  if (!galleryLoader) galleryLoader = import('./lv85-gallery-core.js');
  return galleryLoader;
};
if (document.querySelector(gallerySelector)) {
  loadGallery();
} else {
  let frame = 0;
  const pending = new Set();
  const observer = new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === 1) pending.add(node);
      }
    }
    if (frame || !pending.size) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      let found = false;
      for (const node of pending) {
        if (!node.isConnected) continue;
        let parent = node.parentElement;
        while (parent && !pending.has(parent)) parent = parent.parentElement;
        if (parent) continue;
        if (node.matches(gallerySelector) || node.querySelector(gallerySelector)) {
          found = true;
          break;
        }
      }
      pending.clear();
      if (found) {
        observer.disconnect();
        loadGallery();
      }
    });
  });
  observer.observe(document.documentElement, {childList: true, subtree: true});
}
